module.exports = __webpack_public_path__ + "as.svg?43207abfbc95987d732e50d476980977";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/as.svg
// module id = 1186
// module chunks = 27